module.exports = __webpack_public_path__ + "img/map.6a7ee70.svg";